<template>
  <div class="layout">
    <div style="text-align:right;margin-bottom:10px;">
        <!-- 提交 -->
        <Button v-if="!btnDisabled" :loading="loading" type="primary" @click="handleSubmit()">
            {{$t('commonTw.t4')}}
        </Button>
        <Button @click="goBack">
            {{$t('commonTw.t3')}}
        </Button>
    </div>
    <Form ref="reworkForm" :model="rwFormObjs" :rules="rwFormRules" :label-width="100">
        <Collapse v-model="coolapseVal">
            <Panel name="1">
                <!-- 表单信息 -->
                {{$t('reworkProcess.t14')}}
                <div slot="content" class="clearfix">
                <Row>
                    <Col :span="8">
                    <!-- 流程编号 -->
                        <FormItem :label="$t('reworkProcess.t15')">
                            <Input type="text" v-model="rwFormObjs.FLOWNO" :title="rwFormObjs.FLOWNO" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 故障原因 -->
                        <FormItem :label="$t('reworkProcess.t8')">
                            <Input type="text" v-model="rwFormObjs.REWORK_CAUSE" :title="rwFormObjs.REWORK_CAUSE" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 发起日期 -->
                        <FormItem :label="$t('reworkProcess.t12')">
                            <Input type="text" v-model="rwFormObjs.DATETIME_CREATED" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 发起人 -->
                        <FormItem :label="$t('reworkProcess.t11')">
                            <Input type="text" v-model="rwFormObjs.USER_CREATED" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 采购订单号 -->
                        <FormItem :label="$t('reworkProcess.t16')">
                            <Input type="text" v-model="rwFormObjs.PO_NUMBER" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 返修前产品编码 -->
                        <FormItem :label="$t('reworkProcess.t17')">
                            <Input type="text" v-model="rwFormObjs.PRODUCT_CODE" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 产品型号 -->
                        <FormItem :label="$t('reworkProcess.t18')">
                            <Input type="text" v-model="rwFormObjs.PRODUCT_MODEL" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 订单数量 -->
                        <FormItem :label="$t('reworkProcess.t19')">
                            <Input type="text" v-model="rwFormObjs.ORDER_QTY" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 返工数 -->
                        <FormItem :label="$t('reworkProcess.t20')">
                            <Input type="text" v-model="rwFormObjs.REWORK_QTY" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 产品描述 -->
                        <FormItem :label="$t('reworkProcess.t21')">
                            <Input type="text" v-model="rwFormObjs.PRODUCT_DESC" :title="rwFormObjs.PRODUCT_DESC" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 销往地 -->
                        <FormItem :label="$t('reworkProcess.t22')">
                            <Input type="text" v-model="rwFormObjs.COUNTRY_CODE" :title="rwFormObjs.COUNTRY_CODE" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 产线 -->
                        <FormItem :label="$t('reworkProcess.t23')">
                            <Input type="text" v-model="rwFormObjs.LINE_NAME" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 车间 -->
                        <FormItem :label="$t('reworkProcess.t24')">
                            <Input type="text" v-model="rwFormObjs.SEG_NAME" :title="rwFormObjs.SEG_NAME" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 计划返工日期 -->
                        <FormItem :label="$t('reworkProcess.t13')" prop="PLAN_REWORK_DATE">
                            <DatePicker type="date" v-model="rwFormObjs.PLAN_REWORK_DATE" style="width:100%" transfer  :disabled="btnDisabled" format= 'yyyy/MM/dd'></DatePicker>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 返工频次 -->
                        <FormItem :label="$t('reworkProcess.t25')">
                            <Input type="text" v-model="rwFormObjs.REWORK_FREQUENCY" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 返修后产品编码 -->
                        <FormItem :label="$t('reworkProcess.t26')">
                            <Input type="text" v-model="rwFormObjs.PRODUCT_CODE_AFTER" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="8">
                    <!-- 返工类型 -->
                        <FormItem :label="$t('reworkProcess.t27')">
                            <Input type="text" v-model="rwFormObjs.REWORK_TYPE" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="24">
                    <!-- 返工原因 -->
                        <FormItem :label="$t('reworkProcess.t28')">
                            <Input type="text" v-model="rwFormObjs.REWORK_RESON" :title="rwFormObjs.REWORK_RESON" disabled/>
                        </FormItem>
                    </Col>
                    <Col :span="24">
                    <!-- 原因分析 -->
                        <FormItem :label="$t('reworkProcess.t29')" prop="CAUSE_ANALYSIS">
                            <Input type="textarea" v-model.trim="rwFormObjs.CAUSE_ANALYSIS" :title="rwFormObjs.CAUSE_ANALYSIS" :disabled="btnDisabled"/>
                        </FormItem>
                    </Col>
                </Row>
                </div>
            </Panel>
        </Collapse>

        <Collapse v-model="coolapseVal2" class="mg-t-10">
            <Panel name="1">
                <!-- 返工方案 -->
                <span style="color:red;">*</span>{{$t('reworkProcess.t30')}}
                <div slot="content" class="clearfix table-wrap">
                    <Row>
                        <Col :span="24">
                        <!-- 返工方案 -->
                            <FormItem :label="$t('reworkProcess.t30')" prop="REWORK_PROJECT">
                                <Input type="textarea" v-model.trim="rwFormObjs.REWORK_PROJECT" :title="rwFormObjs.REWORK_PROJECT" :disabled="btnDisabled"/>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="8">
                        <!-- 返工工时 -->
                            <FormItem :label="$t('reworkProcess.t31')" prop="REWORK_HOUR">
                                <Input type="text" v-model.trim="rwFormObjs.REWORK_HOUR" :title="rwFormObjs.REWORK_HOUR" :disabled="btnDisabled"/>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                        <!-- 返工人数 -->
                            <FormItem :label="$t('reworkProcess.t32')" prop="WORKER_QTY">
                                <Input type="text" v-model.trim="rwFormObjs.WORKER_QTY" :title="rwFormObjs.WORKER_QTY" :disabled="btnDisabled"/>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                        <!-- 难度系数 -->
                            <FormItem :label="$t('reworkProcess.t33')" prop="DIFFICULTY_COEFFICIENT">
                                <Input type="text" v-model.trim="rwFormObjs.DIFFICULTY_COEFFICIENT" :title="rwFormObjs.DIFFICULTY_COEFFICIENT" :disabled="btnDisabled"/>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
            </Panel>
        </Collapse>

        <Collapse v-model="coolapseVal3" class="mg-t-10">
            <Panel name="1">
                <!-- 返工步骤 -->
                <span style="color:red;">*</span>{{$t('reworkProcess.t34')}}
                <!-- 新增行 -->
                <Button v-if="!btnDisabled" size="small" type="primary" class="mg-l-30" @click.stop="addBtnClick">
                    {{$t('reworkProcess.t35')}}
                </Button>
                <div slot="content" class="clearfix table-wrap">
                    <mAssemblyTable
                        :columns="block.tableColumns"
                        :data="block.tableData"
                        :settings="block.settings"
                        :loading="block.loading"
                        :thDrag="true"
                        ref="blockRef"
                    ></mAssemblyTable>
                </div>
            </Panel>
        </Collapse>

        <Collapse v-model="coolapseVal4" class="mg-t-10">
            <Panel name="1">
                <!-- 发起附件 -->
                {{$t('reworkProcess.t36')}}
                <div slot="content" class="clearfix">
                    <Upload
                            :action="uploadFileUrl1" 
                            :format="fileTypeList"
                            ref="uploadFileRef" 
                            :multiple="false"
                            :show-upload-list="false"
                            :before-upload="beforeUpload"
                            :on-progress="uploadProgress"
                            :on-success="successUpload" :on-error="failUpload"
                            :on-format-error="onFormatError"
                            :on-form-change="fileUpload" 
                            :on-remove="removeFile" 
                            :disabled="btnDisabled">
                            <!-- 选择上传文件 -->
                        <Button icon="ios-cloud-upload-outline" :loading="uploadLoading" :disabled="btnDisabled">
                            {{$t('reworkProcess.t37')}}
                        </Button>
                    </Upload>
                    <p v-for="(item, i) in uploadFiles" :key="i" style="margin: 5px 0;">
                    <a href="javascript:void(0)" style="display:inline-block;margin-right:20px;" @click.prevent="downloadFile(item.annexId)">{{item.annexName}}</a>
                    <Button v-if="item.annexId" size="small" type="primary"  @click="downloadFile(item.annexId)">
                        <!-- 下载 -->
                        {{$t('HSInspectManageMat.t37')}}
                    </Button>
                    <Button v-if="!btnDisabled && item.annexId" size="small" type="error" @click="deleteFile(item.annexId)">
                        <!-- 删除 -->
                        {{$t('commonTw.t5')}}
                    </Button>
                    </p>
                    <span v-if="!btnDisabled" style="color:red;">
                        <!-- 文件大小不能超过 10M -->
                        {{$t('typeTestProcessSearch.t58')}}
                    </span>
                </div>
            </Panel>
        </Collapse>
    </Form>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
export default {
    name: 'reworkProcessDetail',
    components: {
        mAssemblyTable
    },
    data () {
        return {
            coolapseVal: '1',
            coolapseVal2: '1',
            coolapseVal3: '1',
            coolapseVal4: '1',
            flowId: '',
            currStatus: '',
            mdmCode: '',
            loading: false,
            rwFormObjs: {
                FLOW_STATUS: '',            // 状态
                FLOWID: '',                 //流程id
                PLAN_REWORK_DATE: '',       // 计划返工日期
                CAUSE_ANALYSIS: '',         // 原因分析
                REWORK_PROJECT: '',         // 返工方案
                REWORK_HOUR: '',            // 返工工时
                WORKER_QTY: '',             // 返工人数
                DIFFICULTY_COEFFICIENT: '', // 难度系数
                REWORK_DTL: []              //返工步骤 数组
            },
            rwFormRules: {
                PLAN_REWORK_DATE: [
                    // 报告日期不能为空
                    { required: true, type: 'date', message: this.$t('reworkProcess.t38'), trigger: 'change' }
                ],
                CAUSE_ANALYSIS: [
                    // 原因分析不能为空
                    { required: true, message: this.$t('reworkProcess.t39'), trigger: 'blur' }
                ],
                REWORK_PROJECT: [
                    // 返工方案不能为空
                    { required: true, message: this.$t('reworkProcess.t40'), trigger: 'blur' }
                ],
                REWORK_HOUR: [
                    // 返工工时不能为空
                    { required: true, message: this.$t('reworkProcess.t41'), trigger: 'blur' },
                    // 返工工时必须为有效数值
                    { type: 'string', pattern:/^[+-]?(0|([1-9]\d*))(\.\d+)?$/, message: this.$t('reworkProcess.t44'), trigger:'blur'}
                ],
                WORKER_QTY: [
                    // 返工人数不能为空
                    { required: true, message: this.$t('reworkProcess.t42'), trigger: 'blur' },
                    // 返工人数必须为有效数值
                    { type: 'string', pattern:/^[0-9]+$/, message: this.$t('reworkProcess.t45'), trigger:'blur'}
                ],
                DIFFICULTY_COEFFICIENT: [
                    // 难度系数不能为空
                    { required: true, message: this.$t('reworkProcess.t43'), trigger: 'blur' },
                    // 难度系数必须为有效数值
                    { type: 'string', pattern:/^[+-]?(0|([1-9]\d*))(\.\d+)?$/, message: this.$t('reworkProcess.t46'), trigger:'blur'}
                ]
            },
            block: {
                settings: {
                    needPager: false,
                    showElevator: false,
                    showSizer: false,
                    pageSizeOpts: [10, 30, 50, 80],
                    needSearch: false,
                    needValidation: false,
                    needTable: true,
                    loading: false,
                    onlyLeftPart: false,
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                tableColumns: {
                    showCheckbox: false,
                    showButtons: true,
                    columns: [
                        {
                            title: this.$t('commonTw.t6'), // 序号
                            key: 'SEQ',
                            align: 'center',
                            width: 60,
                            render: (h, params) => {
                                params.row.SEQ = params.index + 1;
                                this.block.tableData[params.index] = params.row;
                                return h("div", {}, params.row.SEQ);
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('reworkProcess.t34'), // 返工步骤
                            key: 'REWORK_PROCESS',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.REWORK_PROCESS,
                                            disabled:!params.row.REWORK_PROCESS,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.REWORK_PROCESS,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.REWORK_PROCESS = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!this.btnDisabled) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.REWORK_PROCESS,
                                            disabled: !params.row.REWORK_PROCESS,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.REWORK_PROCESS);
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('reworkProcess.t47'), // 返工工具
                            key: 'REWORK_TOOL',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.REWORK_TOOL,
                                            disabled:!params.row.REWORK_TOOL,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.REWORK_TOOL,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.REWORK_TOOL = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!this.btnDisabled) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.REWORK_TOOL,
                                            disabled: !params.row.REWORK_TOOL,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.REWORK_TOOL);
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('reworkProcess.t48'), // 注意事项
                            key: 'REMARK',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.REMARK,
                                            disabled:!params.row.REMARK,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.REMARK,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.REMARK = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!this.btnDisabled) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.REMARK,
                                            disabled: !params.row.REMARK,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.REMARK);
                                }
                            }
                        },
                        {
                            title: this.$t('HSInspectManageMat.t54'), // 操作
                            key: 'opt',
                            align: 'center',
                            minWidth: 60,
                            render: (h, params) => {
                                let del2 = h('Button',
                                    {
                                        props: {
                                            type: 'text',
                                            icon: 'trash-b',
                                            disabled: false
                                        },
                                        style: {fontSize: '16px',padding: '0 5px'},
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('reworkProcess.t9'), // 您确认删除这条内容吗？
                                                    onOk: () => {
                                                        this.block.tableData.splice(params.index, 1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                );
                                if (!this.btnDisabled) {
                                    return del2;
                                }
                            }
                        }
                    ]
                },
                tableData: [],
                loading: false,
                condition: {},
            },
            // 附件
            fileTypeList: ['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml', 'rar', 'zip', '7z'],
            uploadFiles: [], // 附件列表
            uploadLoading: false,
            btnDisabled: true,
            uploadFileUrl: '/qms2gsc/file/upload?',
            uploadFileUrl1: '/qms2gsc/file/upload',
        };
    },
    methods: {
        // 创建‘*’
        createSpanX(h) {
            return h("span",
                {
                    props: {
                        size: 20,
                    },
                    style: {
                        color: "red",
                    },
                },
                "*"
            );
        },
        // 创建Span
        createSpan(h, params) {
            return h("span",
                {
                    props: {
                        size: 20,
                    },
                    style: {
                        "font-weight": "bold",
                    },
                },
                params.column.title
            );
        },
        submitTips () {
            this.$Modal.success({
                title: this.$t('HSInspectManageMat.t48'), // 提示
                content: this.$t('HSInspectManageMat.t43'), // 提交成功
                closable: false,
                onOk: () => {
                    this.$closeTab({
                        name: 'reworkProcessDetail'
                    });
                    this.$router.push({ name: 'reworkProcess' });
                }
            });
        },
        showTips (msg, key = 'loading') {
            this[key] = false;
            this.$Modal.error({
                title: this.$t('HSInspectManageMat.t48'),
                content: msg || this.$t('HSInspectManageMat.t49')
            });
        },
        /** 新增行 */
        addBtnClick() {
            // let len = this.block.tableData.length + 1;
            let addObj = {
                // SEQ: len, // gsc新增无SEQ
                REWORK_PROCESS: '', // 返工步骤
                REWORK_TOOL: '', // 返工工具
                REMARK: '', // 注意事项
            };
            this.block.tableData.push(addObj);
        },
        validRow() {
            let flag = true;
            this.$refs.reworkForm.validate((valid) => {
                if (valid) {
                    let len = this.block.tableData.length;
                    if (len === 0) {
                        flag = false;
                        this.$Message.warning(this.$t('reworkProcess.t50')); // 返工步骤至少新增一行
                        return false;
                    }
                    for (let i = 0; i < len; i++) {
                        let obj = this.block.tableData[i];
                        // 返工步骤
                        if (!obj.REWORK_PROCESS) {
                            this.showTips(this.$t('reworkProcess.t51')); // 返工步骤不能为空
                            flag = false;
                            return false;
                        }
                        // 返工工具
                        if (!obj.REWORK_TOOL) {
                            this.showTips(this.$t('reworkProcess.t52')); // 返工工具不能为空
                            flag = false;
                            return false;
                        }
                        // 注意事项
                        if (!obj.REMARK) {
                            this.showTips(this.$t('reworkProcess.t53')); // 注意事项不能为空
                            flag = false;
                            return false;
                        }
                    }
                    console.log('this.uploadFiles::', this.uploadFiles);
                } else {
                    flag = false;
                }
            });
            return flag;
        },
        handleSubmit () {
            // console.log(`JSON.parse(localStorage.getItem('supplierInfo'))`, JSON.parse(localStorage.getItem('supplierInfo')))
            // return
            if (!this.validRow()) {
                return false;
            }
            let params = {
                OPERATION_TYPE: 'handler_pass',//通过:handler_pass 驳回:handler_refuse
                AUDIT_NOTE: '',//审批意见
                FLOW_STATUS: this.rwFormObjs.FLOW_STATUS, // 状态
                FLOWID: this.rwFormObjs.FLOWID, //流程id
                PLAN_REWORK_DATE: this.rwFormObjs.PLAN_REWORK_DATE ? moment(this.rwFormObjs.PLAN_REWORK_DATE).format('YYYY/M/D') : '', // 计划返工日期
                CAUSE_ANALYSIS: this.rwFormObjs.CAUSE_ANALYSIS, // 原因分析
                REWORK_PROJECT: this.rwFormObjs.REWORK_PROJECT, // 返工方案
                REWORK_HOUR: Number(this.rwFormObjs.REWORK_HOUR), // 返工工时
                WORKER_QTY: Number(this.rwFormObjs.WORKER_QTY), // 返工人数
                DIFFICULTY_COEFFICIENT: Number(this.rwFormObjs.DIFFICULTY_COEFFICIENT), // 难度系数
                REWORK_DTL: [...this.block.tableData],
                USER_NAME: JSON.parse(localStorage.getItem('supplierInfo')).userName.toLocaleUpperCase(), // JSON.parse(localStorage.getItem('user')).loginName.toLocaleUpperCase(),
                language: this.$i18n.locale
                // LANGUAGE: 'ZHS'
            };
            this.loading = true;
            axios.post('/qms2gsc/oemRework/ProgrammeInputApproveProcessForeign', params)
            .then((res) => {
                this.loading = false;
                let rep = res.data;
                if (rep.result) {
                    this.submitTips();
                } else {
                    this.showTips(rep.msg);
                }
            })
            .catch(() => {
                this.showTips(null, 'loading');
            });
        },
        goBack () {
            this.$closeTab({
                name: 'reworkProcessDetail'
            });
            this.$router.push({ name: 'reworkProcess' });
        },
        beforeUpload (file) {
            console.log('beforeUpload::', file);
            if (file.size > 10485760) {
                this.$Message.warning({
                    title: this.$t('HSInspectManageMat.t48'), // this.$t('common.warn'),
                    content: this.$t('typeTestProcessSearch.t58') // 文件大小不能超过10M！
                });
                return false;
            }
        },
        uploadProgress(event, file, fileList) {
            this.uploadLoading = true;
        },
        successUpload (response, file, fileList) {
            console.log('uploadSuccess::', response, file, fileList);
            let jsonStr = response.substring(1).substring(0, response.length - 3);
            let result = JSON.parse(jsonStr);
            console.log('result', result);
            if (result.IsSucess) {
                // this.uploadFiles = [];
                console.log('this.uploadFiles', this.uploadFiles)
                this.uploadFiles.push({
                    annexName: file.name,
                    annexId: result.MainResultData,
                });
                console.log('this.uploadFiles---', this.uploadFiles)
                this.uploadLoading = false;
                // this.$Message.success(this.$t('上传成功')); // 上传成功
            } else {
                this.uploadLoading = false;
                debugger
                this.showTips();
            }
        },
        failUpload () {
            this.showTips(this.$t('HSInspectManageMat.t79')); // 附件上传失败，请重新上传
            this.uploadLoading = false;
            this.$refs.uploadFileRef.clearFiles();
        },
        onFormatError() {
            this.uploadLoading = false;
            this.$Modal.error({
                content: this.$t('typeTestProcessSearch.t122').replace('_', this.fileTypeList.join()) // 图片附件只支持${this.fileTypeList.join()}格式
            });
        },
        fileUpload (file) {
            console.log('``````fileUpload``````::', file);
        },
        removeFile (file) {
            // let id = JSON.parse(file.response.substring(1).substring(0, file.response.length - 3)).MainResultData;
            // axios.get(`/qms2gsc/file/delete?id=${id}`);
        },
        downloadFile (id) {
            window.open(`/qms2gsc/file/download?id=${id}`);
        },
        deleteFile (annexId) {
            if (!annexId) {
                return false;
            }
            axios.post('/qms2gsc/file/delete' + '?id=' + annexId + '&deletefile=Y', {}).then(res => {
                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                let result = JSON.parse(jsonStr);
                var IsSucess = result.IsSucess;
                if (IsSucess === true) {
                    this.uploadFiles.forEach((item, index, arr) => {
                        if (item.annexId === annexId) {
                            arr.splice(index, 1);
                        }
                    });
                    this.$Message.success(this.$t('typeTestProcessSearch.t129')); // 删除成功
                } else {
                    this.$Modal.error({
                        title: this.$t('HSInspectManageMat.t48'),
                        content: this.$t('typeTestProcessSearch.t104') // 删除失败
                    });
                }
            }).catch(() => {
                this.$Modal.error({
                    title: this.$t('HSInspectManageMat.t48'),
                    content: this.$t('HSInspectManageMat.t49')
                });
            });
        },
        // 获取发起附件
        getDownLoadFiles (id) {
            this.uploadFiles = [];
            axios.get(`/qms2gsc/File/GetList?busid=${id}`)
            .then((res) => {
                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                let result = JSON.parse(jsonStr);
                let fileList1 = [];
                if (result.IsSucess) {
                    result.MainResultData.forEach(item => {
                        fileList1.push({
                            annexName: item.FILE_NAME,
                            annexId: item.ID,
                        });
                    });
                }
                this.uploadFiles = fileList1;
                this.$set(this, 'uploadFiles', fileList1);
                // debugger
            });
        },
        setData(data) {
            this.rwFormObjs = data;
            this.block.tableData = [];
            this.block.tableData = data.REWORK_DTL;
            this.uploadFileUrl1 = this.uploadFileUrl + `busid=${data.REWORK_ID}`;
            this.btnDisabled = this.currStatus !== 'N'; // 'N'表示待处理'Y'表示已处理
            this.getDownLoadFiles(data.REWORK_ID);
        },
        getDetailData () {
            let params = {};
            if (this.currStatus === 'N') {
                // 待处理
                params.status = '0'; // 0表示待处理
            } else { // 已处理
                params.status = '1'; // 1表示非待处理
            }
            params.supplier_code = this.mdmCode;
            params.FLOWID = this.flowId;
            params.language = this.$i18n.locale;
            axios.post('/qms2gsc/oemRework/getListForeign', params)
            .then((res) => {
                this.loading = false;
                let rep = res.data;
                if (rep.result) {
                    let data = rep.data;
                    this.setData(data[0]);
                } else {
                    this.$Modal.error({
                        title: this.$t('HSInspectManageMat.t48'),
                        content: this.$t('HSInspectManageMat.t49')
                    });
                }
            }).catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('HSInspectManageMat.t48'),
                    content: this.$t('HSInspectManageMat.t49')
                });
            });
        }
    },
    mounted () {
        this.mdmCode = JSON.parse(localStorage.getItem('supplierInfo')).mdmCode;
        this.flowId = this.$route.query.FLOWID;
        this.currStatus = this.$route.query.currStatus;
        this.getDetailData();
    }
};
</script>
<style lang="less" scoped>
.layout {
    background: #FFF;
    padding: 10px 10px 20px; 
}
/deep/ .m-collapse-content{
  padding: 14px 10px;
}
/deep/ .m-collapse-content>.m-collapse-content-box{
    padding: 0;
}
// /deep/ .m-form .m-form-item-label{
//     padding-right: 5px;
// }
.table-wrap {
    /deep/ .m-card-body {
        padding: 0px;
    }
}
.mg-l-30 {
    margin-left: 30px;
}
.mg-t-10 {
    margin-top: 10px;
}
/deep/ .m-form-item-label{
    height: 0;
}
</style>
